import { Link } from 'react-router-dom';
import LogoDark from '../../images/logo/logo-dark.svg';
import Logo from '../../images/icon/black-majles-logo.png';
import { useState, useContext } from 'react'
import { DataContext } from '../../context/DataProvider';
import { useForm } from "react-hook-form";

const SignUp = () => {
  const { Register } = useContext(DataContext)
  
  const [UserInfoRegister, setUserInfoRegister] = useState({
    firstName: "",
    lastName: "",
    Username: "",
    Password: "",
    confirmPassword: "",
    email:""
})

const {
  register,
  handleSubmit,
  reset,
  formState: { errors },
} = useForm();


  
  return (
    <>
  



<div className="py-6 px-4" style={{fontFamily:"Btitr"}}>
        <a
          title="صفحه اصلی"
          className="text-black fixed top-[20px] left-[20px] hover:text-gray-700 duration-200"
          href="#"
        >
          {" "}
        </a>
        <div className="flex bg-white relative rounded-lg border max-w-[600px] border-gray-300 shadow-lg overflow-hidden mx-auto">
          <div className="w-full p-10">
            <h2 className="flex justify-center">
              <img
                width={130}
                height={130}
                src={Logo}
                alt=""
              />
            </h2>
            <form onSubmit={handleSubmit((data) => {
                
                // console.log(adduser);
                  reset()
                  Register(UserInfoRegister)
              })}>

            
            <div className="mt-7 flex items-center justify-between">
              <span className="border-b border-gray-300 w-1/5 lg:w-[30%]"></span>
              <a href="#" className="text-sm text-center text-gray-500 ">
               ثبت نام کاربر 
              </a>
              <span className="border-b border-gray-300 w-1/5 lg:w-[30%]"></span>
            </div>
            <div className="mt-4">
              <label className="block text-gray-700 text-sm mb-2">
                نام 
              </label>
              <div className="relative">
                  <input
                    id="firstname"
                    {...register("firstname", { required: true })}
                  className="bg-gray-100 text-gray-700 border border-gray-300 rounded py-2 pl-4 pr-10 block w-full appearance-none focus:outline-none focus:shadow-outline focus:border-primary"
                  type="text"
                  value={UserInfoRegister.firstName}
                  onChange={(e) => setUserInfoRegister((UserInfoRegister)=>({ ...UserInfoRegister, firstName: e.target.value }))}
                
                  />
                   {errors.firstname && (
                    <p className="Error">نام نمی تواند خالی باشد </p>
                )}
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-gray-700 text-sm mb-2">
                نام خانوادگی 
              </label>
              <div className="relative">
                  <input
                    id="lastname"
                       {...register("lastname", { required: true })}
                  className="bg-gray-100 text-gray-700 border border-gray-300 rounded py-2 pl-4 pr-10 block w-full appearance-none focus:outline-none focus:shadow-outline focus:border-primary"
                  type="text"
                  value={UserInfoRegister.lastName}
                  onChange={(e) => setUserInfoRegister({ ...UserInfoRegister, lastName: e.target.value })}
               
                  />
                   {errors.lastname && (
                    <p className="Error">نام خانوادگی نمی تواند خالی باشد </p>
                )}
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-gray-700 text-sm mb-2">
                ایمیل 
                
              </label>
              <div className="relative">
                  <input
                    id="email"
                    {...register("email",{
                      required: "ایمیل نمی تواند خالی باشد.",
                      pattern:{
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message:"لطفا  آدرس ایمیل را به درستی وارد کنید",
                    }
                    })}
                  className="bg-gray-100 text-gray-700 border border-gray-300 rounded py-2 pl-4 pr-10 block w-full appearance-none focus:outline-none focus:shadow-outline focus:border-primary"
                  type="email"
                  value={UserInfoRegister.email}
                  onChange={(e) => setUserInfoRegister({ ...UserInfoRegister, email: e.target.value })}
                  
                  />
                    {errors.email && <p className="Error">{errors.email.message}</p>}
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-gray-700 text-sm mb-2">
                نام کاربری
              </label>
              <div className="relative">
                  <input
                    id="username"
                    {...register("username", { required: true })}
                  className="bg-gray-100 text-gray-700 border border-gray-300 rounded py-2 pl-4 pr-10 block w-full appearance-none focus:outline-none focus:shadow-outline focus:border-primary"
                  type="text"
                  value={UserInfoRegister.Username}
                  onChange={(e) => setUserInfoRegister({ ...UserInfoRegister, Username: e.target.value })}
                   
                  />
                  {errors.username && (
                  <p className="Error">نام کاربری نمی تواند خالی باشد </p>
                )}
              </div>
            </div>

            <div className="mt-4">
              <label className="block text-gray-700 text-sm mb-2">
                رمز عبور
              </label>
              <div className="relative">
                <input
                  id="password"
                  {...register("password", {
                    required: "کلمه عبور نمی تواند خالی باشد  ",
                    // maxLength: { value: 6, message: "کلمه عبور نباید بیشتر از  6 کاراکتر باشد " },
                    minLength: { value: 8, message: "کلمه عبور نباید کمتر از 8 کارکتر باشد " },
                    pattern:{
                      value: /^[A-Z0-9a-z@!$#&]/,
                      message:"کلمه عبور باید ترکیبی از حروف بزرگ و کوچک و اعداد باشد. ",
                  }
                })}
                  className="bg-gray-100 text-gray-700 border border-gray-300 rounded py-2 pl-4 pr-10 block w-full appearance-none focus:outline-none focus:shadow-outline focus:border-primary"
                  type="password"
                  value={UserInfoRegister.Password}
                  onChange={(e) => setUserInfoRegister({ ...UserInfoRegister, Password: e.target.value })}
                 
                  
                  
                />
{errors.password && <p className="Error">{errors.password.message}</p>}
                {/* <button id="show-btn"></button> */}
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-gray-700 text-sm mb-2">
                 تکرار رمز عبور
              </label>
              <div className="relative">
                <input
                  // id="password-input"
                  className="bg-gray-100 text-gray-700 border border-gray-300 rounded py-2 pl-4 pr-10 block w-full appearance-none focus:outline-none focus:shadow-outline focus:border-primary"
                  type="password"
                  value={UserInfoRegister.confirmPassword}
                  id="confirmpassword"
                  {...register("confirmpassword", { required: "لطفا کلمه عبور را تایید کنید" ,})}
                  onChange={(e) => setUserInfoRegister({ ...UserInfoRegister, confirmPassword: e.target.value })}
                />
 {errors.confirmpassword && (
                  <p className="Error">{errors.confirmpassword.message}</p>
                )}
                {/* <button id="show-btn"></button> */}
              </div>
            </div>
           
            {/* <div>
              {" "}
              <a
                className="text-[12px] text-primary hover:text-black duration-200"
                href="#"
              >
                رمز عبور خود را فراموش کردید ؟
              </a>
            </div> */}

            {/* <div className="flex items-center justify-center gap-2 mt-5">
              <input type="checkbox" id="remember-me" />
              <label className="text-[12px] " htmlFor="remember-me">
                مرا به خاطر بسپار
              </label>
            </div> */}
            <div className="mt-8 flex justify-center">
              <button className=" w-[30%] bg-primary border-2  rounded-lg p-3 text-white hover:bg-white hover:text-primary
               hover:border-blue-500 " type="submit">
                ثبت نام 
              </button>
            </div>
            </form>
            {/* <div className="mt-10 flex items-center justify-between">
              <span className="border-b border-gray-300 w-1/5 md:w-1/4"></span>
              <a href="/signup" className="text-xs text-gray-500 mx-2 ">
                حساب کاربری ندارید؟{" "}
                <span className="text-primary">ثبت نام کنید </span>
              </a>
              <span className="border-b border-gray-300 w-1/5 md:w-1/4"></span>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
